var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.9091C16 12.2708 15.8563 12.6176 15.6006 12.8733C15.3449 13.1291 14.998 13.2727 14.6364 13.2727H2.36364C2.00198 13.2727 1.65513 13.1291 1.3994 12.8733C1.14367 12.6176 1 12.2708 1 11.9091V4.40909C1 4.04743 1.14367 3.70059 1.3994 3.44485C1.65513 3.18912 2.00198 3.04545 2.36364 3.04545H5.09091L6.45455 1H10.5455L11.9091 3.04545H14.6364C14.998 3.04545 15.3449 3.18912 15.6006 3.44485C15.8563 3.70059 16 4.04743 16 4.40909V11.9091Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50071 10.5454C10.0069 10.5454 11.228 9.32432 11.228 7.81809C11.228 6.31186 10.0069 5.09082 8.50071 5.09082C6.99448 5.09082 5.77344 6.31186 5.77344 7.81809C5.77344 9.32432 6.99448 10.5454 8.50071 10.5454Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.64384ff6102e505a22d9370561ef54d7.svg";
export { ForwardRef as ReactComponent };